import SectionInsightSingle from "./section-insight-single";
import SectionRelatedInsights from "./section-related-insights";
import SectionComments from "./section-comments";
import { blogPosts } from "../../../../globals/neuron-content";

function SectionInsightDetailInner({ currentPost, currentIndex }) {
    const safePost = currentPost ?? blogPosts[0];
    const commentUrl = `/insights/${safePost.slug}#comments`;

    return (
        <>
            <SectionInsightSingle currentPost={safePost} currentIndex={currentIndex} />
            <SectionRelatedInsights currentPost={safePost} />
            <SectionComments commentUrl={commentUrl} />
        </>
    )
}

export default SectionInsightDetailInner;
